<div class="ion-page modal-body" style="width: 100%;margin: 0px !important;padding: 0px !important;">
  <div class="modalInnerWrapper modal-content">
    <div class="modal-body">
      <h4 class="t-h4 t-medium" style="margin-top: 0px !important;">PDF viewer</h4>


      <ngx-extended-pdf-viewer   height="90vh"
      [src]="pdfurl"

      (currentZoomFactor)="updateZoomFactor($event)"
      [useBrowserLocale]="true"
      [(zoom)]="zoomSetting"
      [showZoomButtons]="true"
      [minZoom]="minZoom"
      
      [zoomLevels]="zoomLevels"
      [enablePinchOnMobile]="enablePinchOnMobile"
      ></ngx-extended-pdf-viewer>

      
      
    </div>
    <!-- <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon> -->
    <button (click)="dismiss()" type="link" class="close">
      <span class="icon icon-close"></span>
    </button>
  </div>
</div>